export const useStyles = (theme) => ({
  appbarStyle: {
    bottom: 0,
    background: "#17263d",
    boxShadow: "none",
    backdropFilter: `blur(4px)`,
    [theme.breakpoints.down("sm")]: {
      background: "transparent",
      backgroundColor: "#17263d",
    },
  },
  textStyle: {
    display: "flex",
    justifyContent: "center",
  },
  listStyle: {
    width: "80%",
    listStyle: "none",
    display: "flex",
    justifyContent: "center",
    flexDirection: "row",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      paddingTop: 100,
    },
  },
  itemList: {
    marginRight: 20,
    [theme.breakpoints.down("sm")]: {
      marginBottom: 20,
    },
  },
  buttonStyle: {
    width: "10%",
    display: "flex",
    justifyContent: "center",
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  drawerPaper: {
    background: `linear-gradient(to bottom,#96f389,#3db7f8)`,
    width: 200,
    height: 400,
    backdropFilter: `blur(4px)`,
  },
  theme: {
    direction: "rtl1",
  },
  menuButton: {
    padding: 0,
    color: "black",
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
});
